import React, { createContext, useContext, useRef } from 'react';

const FormFocusContext = createContext(null);

export function FormFocusProvider({ children }) {
  const refs = {
    you: {
      smokingStatus: useRef(null),
      sex: useRef(null)
    },
    partner: {
      smokingStatus: useRef(null),
      sex: useRef(null)
    }
  };

  const focusField = (person, field) => {
    if (refs[person]?.[field]?.current) {        
      refs[person][field].current.focus();
    }
  };

  return (
    <FormFocusContext.Provider value={{ refs, focusField }}>
      {children}
    </FormFocusContext.Provider>
  );
}

export function useFormFocus() {
  const context = useContext(FormFocusContext);
  if (!context) {
    throw new Error('useFormFocus must be used within a FormFocusProvider');
  }
  return context;
}